'use strict';

const creditCardFormats = {
    'AX': /(\d{4})?(?:\s)?(\d{6})?(?:\s)?(\d{1,5})?/,
    'default': /(\d{4})?(?:\s)?(\d{4})?(?:\s)?(\d{4})?(?:\s)?(\d{1,4})?/,
};

const specialCharacters = '\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00e0\u00e1\u00e2\u00e3\u00e4' +
    '\u00e5\u00c6\u00e6\u00df\u00c8\u00c9\u00ca\u00cb\u00e8\u00e9\u00ea\u00eb\u00cc\u00cd\u00ce' +
    '\u00cfI\u0130\u00ec\u00ed\u00ee\u00ef\u0131i\u0152\u0153\u00d2\u00d3\u00d4\u00d5\u00d6\u00d8' +
    '\u00f8\u00f2\u00f3\u00f4\u00f5\u00f6\u00f8\u00d9\u00da\u00db\u00dc\u00f9\u00fa\u00fb\u00fc' +
    '\u0178\u00dd\u00fd\u00ff\u00c7\u00e7\u00d1\u00f1\u00d0\u00fe\u00de\u00b5\u0160\u0161Ss\u015e' +
    '\u015fG\u011eg\u011f\u0192';

const latinCharactersFormat = `[^- 'A-Za-z${specialCharacters}]`;

let selectedCreditCard = 'default';

const setSelectedCreditCard = function(creditCard) {
    selectedCreditCard = creditCard === 'AX' ? 'AX' : 'default';
};

const patternMap = {
    latinCharacters: function(value) {
        const regex = RegExp(latinCharactersFormat, 'gi');
        return value.replace(regex, '');
    },
    numbers: function(value) {
        return value.replace(/[^0-9]/gi, '');
    },
    ccnumber: function(value) {
        return value.replace(/^[ 0/-]*/, '').replace(/[^0-9 \-/]/gi, '');
    },
    ccNumberFormatted: function(value) {
        const replacedValue = this.numbers(value);
        const pattern = creditCardFormats[selectedCreditCard];
        const match = pattern.exec(replacedValue);
        return Odigeo._.filter(Odigeo._.tail(match), function(number) {
            return !isNaN(number);
        }).join(' ');
    },
};

const onPasteCC = () => {
    setSelectedCreditCard('default');
};

const initInputPattern = function(wrapper) {
    const $wrapper = (wrapper instanceof $) ? wrapper : $(wrapper);
    const pattern = $wrapper.data('pattern-type') ? $wrapper.data('pattern-type') : $wrapper.data('pattern');

    if ($wrapper.length && pattern && patternMap[pattern]) {
        $wrapper.on(Odigeo.Events.paste, onPasteCC);
        $wrapper.on(Odigeo.Events.input, Odigeo._.partial(onInputValueCheck, $wrapper, pattern));
    }
};

const onInputValueCheck = function($wrapper, pattern) {
    let position = this.selectionStart;
    const value = $wrapper.val();
    const newValue = patternMap[pattern](value);

    if (value !== newValue) {
        $wrapper.val(newValue);

        if (newValue[position - 1] === ' ' && newValue[position - 1] !== value[position - 1]) {
            position = position + 1;
        }
        if (Odigeo.SessionScope.flow !== 'mobile') {
            $wrapper[0].setSelectionRange(position, position);
        } else {
            Odigeo._.delay(function() {
                $wrapper[0].setSelectionRange(position, position);
            }, 0);
        }
        $wrapper.trigger(Odigeo.Events.change);
    }
};

module.exports = {
    setSelectedCreditCard: setSelectedCreditCard,
    formatCreditCard: onInputValueCheck,
    initInputPattern: initInputPattern,
    specialCharacters,
};
